module.exports = __webpack_public_path__ + "img/calendar-check-02.6c15cdce.svg";